import { createSlice } from '@reduxjs/toolkit';
import { fetchVacations, createVacation, updateVacation, deleteVacation } from '../thunks/vacationThunks.js';
import { fetchCurrentBalance } from '../thunks/balanceThunks.js';

const initialState = {
    list: [],
    teamVacations: [],
    loading: false,
    maxPageNumber: 0,
    balance: {
        current: 0,
        hireDate: new Date(),
    },
};

const vacationSlice = createSlice({
    name: 'vacations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVacations.fulfilled, (state, action) => {
                Object.assign(state, action.payload);
                state.loading = false;
            })
            .addCase(createVacation.fulfilled, (state, action) => {
                state.list.push(action.payload);
                state.loading = false;
            })
            .addCase(updateVacation.fulfilled, (state, action) => {
                const updated = action.payload;
                state.list = state.list.map((v) => (v.id === updated.id ? updated : v));
                state.loading = false;
            })
            .addCase(deleteVacation.fulfilled, (state, action) => {
                const deletedId = action.payload;
                state.list = state.list.filter((v) => v.id !== deletedId);
                state.loading = false;
            })
            .addCase(fetchCurrentBalance.fulfilled, (state, action) => {
                state.balance = action.payload;
            })
            .addMatcher(
                (action) =>
                    [
                        createVacation.pending.type,
                        updateVacation.pending.type,
                        deleteVacation.pending.type,
                        fetchVacations.pending.type,
                    ].includes(action.type),
                (state) => {
                    state.loading = true;
                },
            )
            .addMatcher(
                (action) =>
                    [
                        createVacation.rejected.type,
                        updateVacation.rejected.type,
                        deleteVacation.rejected.type,
                        fetchVacations.rejected.type,
                    ].includes(action.type),
                (state, action) => {
                    state.error = action.payload || action.error?.message;
                    state.loading = false;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default vacationSlice.reducer;
